import InsteadPage from './src/instead-page';

export default InsteadPage;
